// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const IncentiveService = {}

IncentiveService.getIncentiveAdd = function (prospectId) {
    return lossClient({
        url: `/ApkLoanKKBIncentive/getAdd`,
        method: 'get',
        params: {
            prospectid: prospectId
        }
    })
}

IncentiveService.saveIncentive = function (payload) {
    return lossClient({
        url: `/ApkLoanKKBIncentive/add`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    })
}

export default IncentiveService
